import { useExhibitorStore } from '@/stores/exhibitor/ExhibitorStore';
import { type ArcualInventoryItem, ArcualItemType } from '@arcual/lib-app-platform';

/**
 * enrich listing with reference data
 * @param listing
 */
export const enrichListing = async (listing: ArcualInventoryItem) => {
  listing.seller = (await useExhibitorStore().getExhibitor(listing.sellerProfileId)).value;
  if (
    (listing.itemType === ArcualItemType.EDITION || listing.itemType === ArcualItemType.ARTIST_PROOF) &&
    listing.childMetadata &&
    !listing.childMetadata?.volume &&
    listing.masterMetadata
  ) {
    listing.childMetadata.volume =
      listing.itemType === ArcualItemType.EDITION
        ? listing.masterMetadata.editionsVolume
        : listing.masterMetadata.artistProofsVolume;
  }
};
